import React from 'react';

const AuthLayout = ({ children }) => <main className="min-h-screen bg-white">{children}</main>;

export default AuthLayout;
